import axios from 'axios'
import appConfig from '@/appconfig'
import endpoint from '@constants/apipath'

export const actions = {
  savePassword({ commit }, { UserId, MclID, password }) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }

    let param = JSON.stringify({
      UserId: UserId,
      MCLId: MclID,
      MCLPassword: password,
    })

    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.savemclcredentials}`,
        param,
        {
          headers: headers,
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  fetchMclCredentialsById({ commit }, { userId } = {}) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.getmclcredentails}/${userId}`,
        {
          headers: headers,
        }
      )

      .then((response) => {
        return response.data
      })
  },
}
